import { MdRssFeed } from "react-icons/md";
import { FaHome, FaUser, FaUsers, FaFire, FaBookmark, FaCog, FaVideo, FaCalendarAlt, FaQuestionCircle,     FaCamera, FaGamepad, FaBroadcastTower, FaCompass, FaLifeRing, FaChartLine, FaShieldAlt, FaTrophy } from 'react-icons/fa';


const SidebarIcons = [
    { title: 'Home', iconinfo: FaHome },
    // { title: 'Feed', iconinfo: MdRssFeed },
    { title: 'Profile', iconinfo: FaUser },
    { title: 'Friends', iconinfo: FaUsers },
    { title: 'Trending', iconinfo: FaFire },
    // { title: 'Saved', iconinfo: FaBookmark },
    { title: 'Videos', iconinfo: FaVideo },
    { title: 'Events', iconinfo: FaCalendarAlt },
    { title: 'Questions', iconinfo: FaQuestionCircle },
    { title: 'Settings', iconinfo: FaCog },
    { title: 'Photos', iconinfo: FaCamera },
    { title: 'Games', iconinfo: FaGamepad },
    { title: 'Live Streams', iconinfo: FaBroadcastTower },
    { title: 'Explore', iconinfo: FaCompass },
    { title: 'Support', iconinfo: FaLifeRing },
    { title: 'Analytics', iconinfo: FaChartLine },
    { title: 'Privacy', iconinfo: FaShieldAlt },
    { title: 'Achievements', iconinfo: FaTrophy }
];

export default SidebarIcons;
